// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: 'English',
    introduction:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  docs: {
    hi: 'Hi',
    description: 'Need help? \n Please check our docs.',
    documentation: 'documentation',
  },
  yes: 'yes',
  no: 'no',
  app: 'app',
  noData: 'no data available',
  user: 'user',
  welcomeBack: 'welcome back at TerraIndividual',
  darkMode: 'dark mode',
  lightMode: 'light mode',
  list: 'List',
  edit: 'edit',
  shop: 'shop',
  blog: 'blog',
  post: 'post',
  mail: 'mail',
  chat: 'chat',
  cards: 'cards',
  posts: 'posts',
  create: 'create',
  kanban: 'kanban',
  general: 'General',
  optional: 'Optional',
  banking: 'banking',
  booking: 'booking',
  profile: 'Profile',
  account: 'account',
  product: 'product',
  invoice: 'invoice',
  details: 'details',
  checkout: 'checkout',
  calendar: 'calendar',
  analytics: 'analytics',
  ecommerce: 'e-commerce',
  management: 'management',
  menu_level_1: 'menu level 1',
  menu_level_2a: 'menu level 2a',
  menu_level_2b: 'menu level 2b',
  menu_level_3a: 'menu level 3a',
  menu_level_3b: 'menu level 3b',
  menu_level_4a: 'menu level 4a',
  menu_level_4b: 'menu level 4b',
  item_disabled: 'item disabled',
  item_label: 'item label',
  item_caption: 'item caption',
  item_external_link: 'item external link',
  description: 'description',
  other_cases: 'other cases',
  item_by_roles: 'item by roles',
  only_admin_can_see_this_item: 'Only admin can see this item',
  error: 'error',
  is: 'is',
  on: 'on',
  on2: 'on',
  and: 'and',
  home: 'Home',
  settings: 'Settings',
  logout: 'Logout',
  resetSettings: 'Reset',
  group: 'group',
  understood: 'understood',
  selectedDate: 'selected date',
  dateAlert: 'Set date to Today',
  globalDateIgnoredTooltip:
    'The list currently shown is loaded without date consideration. ' +
    'The global date does not apply here and therefore cannot be changed. ' +
    'Turn off "Show all tours" to filter by the global date again.',
  refresh: {
    label: 'Reload page',
    tourList: 'Reload tour list',
    studentList: 'Reload student list',
    toursAndStudents: 'Reload tours and students',
    unavailable: 'Not available',
  },
  // ########################## //
  /*
  // Dictionary TICL - best practice
  // vocabulary which can be generalized should be at top  as a single line
  // vocabulary which is specic to a item/person i.e. vehicle/student at bottom as a block
  //
  */
  // ########################## //
  salutation: 'Salutation',
  salutation_mr: 'Mr.',
  salutation_mrs: 'Mrs.',
  salutation_none: '-',
  create_successful: 'Create successful!',
  update_successful: 'Update successful!',
  delete_successful: 'Delete successful!',
  deactivate_successful: 'Deactivate successful!',
  delete_not_successful: 'Delete not successful',
  update_not_successful: 'Update not successful!',
  error_on_delete: 'Error on delete',
  revert_successful: 'Revert successful!',
  assigned_place: 'Selected Place',
  search_existing_place_or_geocode_new: 'search existing Place or geocode new place',
  geocode: 'geocode',
  geocode_error: 'please complete address-fields - no geocoding possible',
  create_new_place: 'create new Place',
  publicTransportationStations: 'public transportations',
  publicTransportationStation: 'public transportation',
  mandatoryRoutingPoint: 'mandatory routing point',
  id: 'ID',
  place_typ: 'place Type',
  save: 'save',
  change: 'change',
  deactivate: 'Deactivate',
  save_place: 'save this place',
  select_this_place: 'select this place',
  more_places_in_place_picker: 'More Places',
  gender: 'Gender',
  gender_MALE: 'male',
  gender_FEMALE: 'female',
  gender_DIVERS: 'divers',
  gender_UNDEFINED: '-',
  gender_null: '-',
  employeeRole_DRIVER: 'driver',
  employeeRole_ESCORT: 'escort',
  employeeRoles_DRIVER_ESCORT: 'driver, escort',
  email: 'E-mail',
  phone: 'Phone',
  mobileNumber: 'Mobile number',
  wheelchair: 'Wheelchair',
  please_select: 'Please Select',
  required: 'required',
  is_required: ' is required',
  first_name_required: 'First name required',
  name_required: 'Name required',
  email_required: 'Email required',
  last_name_required: 'Last name required',
  valid_from_required: 'Valid from required',
  valid_until_required: 'Valid until required',
  place_name_required: 'Address name is required',
  street_required: 'Street required',
  house_number_required: 'House number required',
  post_code_required: 'Post Code required',
  place_required: 'Place required',
  title_required: 'title required',
  transportation_company_required: 'transportation company required',
  field_required: '{{field}} required',
  only_number_required: '{{field}} must be number',
  integer_required: '{{field}} must be an integer',
  positive_number_required: '{{field}} must be a positive number',
  min_days_required: 'At least one day must be selected',
  validFromDateOutsideRange: 'From date must be monday and valid',
  validUntilDateOutsideRange: 'Until date must be later than from date and valid',
  validUntilDateOutsideRangeValidFrom: 'Valid until date must be later than the valid from date.',
  update: 'update',
  first_name: 'First name',
  last_name: 'Last name',
  transportationDates: 'Transportation Period',
  transport_from: 'Transport from',
  transport_until: 'Transport until',
  save_changes: 'Save changes',
  dashboard: 'Dashboard',
  comments_and_documents: 'Comments and Documents',
  calendar_and_schedules: 'Calendar and Schedules',
  entries_over_time: 'Changes over time',
  region: 'Federal State',
  selectedShort: 'selected',
  selected: 'selected',
  unselectAll: 'Unselect all',
  onlySelected: 'Only selected',
  onlySelectedTooltip: 'Show only selected entries',
  comment: 'Comment',
  mobilephone: 'mobile phone',
  contactperson: 'contact person',
  show_in_map: 'Show in Map',
  name: 'name',
  vacations_and_deviations: 'vacation and deviation',
  deviations: 'Deviations',
  documents: 'documents',
  map: 'Map',
  prints: 'prints',
  go: 'Go',
  unchanged: 'unchanged',
  cancel: 'cancel',
  delete: 'delete',
  confirmationNeeded: 'Confirmation needed',
  delete_q: 'delete?',
  delete_dialog: 'confirm delete: ',
  delete_confirmation: 'Are you sure to delete ?',
  delete_dialog_of: 'confirm delete of ',
  delete_assure: 'Wollen Sie wirklich folgende (contentType) löschen?',
  deleted: 'deleted',
  error_saving: 'error while saving',
  error_infodialog: 'Oh, something went wrong with',
  online_help: 'online-help',
  sachbearbeiter: 'Sachbearbeiter:in',
  templatedDocumentType: 'Type of template',
  templatedDocument: {
    generalTooltip: 'Mandatory fields',
    optionalTooltip: 'Optional fields, might only be changed in type Genehmigungsschreiben.',
    genehmigungsschreiben: 'Genehmigungsschreiben',
    changeTransportCompany: 'Change transportation company',
  },
  transportationModel: {
    singular: 'standard week',
    plural: 'standard weeks',
    edit: 'edit standard week',
    new: 'new standard week',
    transportationModelReadOnly:
      'standard week cannot be edited because it is already assigned to a student',
    transportationModelReadOnlyHint:
      'standard weeks serve as templates for creating calendar entries for students. Since they can be flexibly applied across different time periods (past or future), subsequent changes to already linked standard weeks would lead to unexpected results. Please create a new standard week instead.',
    delete: 'delete standard week',
    detail: 'view of standard week: ',
    name: 'name of standard week',
    studentListTooltip: 'students of this model at selected date',
    students: 'students',
    deleteError: 'Error while deleting a standard week',
    errorToursExist:
      'error while updating standard week as tours for this standard week already exists',
    errorStudentCalendarEventsExist:
      'error while updating standard week as it is attached to students',
    deleteErrorMessageSingle:
      'The standard week could not be deleted because of existing relations with students.',
    nameRequired: 'name is required',
    validation: {
      toPlaceRequired: '{{day}} - {{hour}}: Outbound type requires a destination',
      fromPlaceRequired: '{{day}} - {{hour}}: Return type requires a starting point',
      transferToPlaceRequired: '{{day}} - {{hour}}: Transfer type requires a destination',
      transferFromPlaceRequired: '{{day}} - {{hour}}: Transfer type requires a starting point',
      unknownType: '{{day}} - {{hour}}: Unknown school hour location type: {{type}}',
    },
  },
  lot: {
    title: 'Lot',
    singular: 'Lot',
    ignoreInCalculation: `ignore in calculations`,
  },
  place: 'place',
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
  way_to: 'way to',
  way_back: 'way back',
  clock: "o'clock",
  transportationPeriod: {
    singular: 'Transportation period',
    plural: 'Transportation periods',
    select: 'Select transportation period',
    delete: 'Delete transportation period',
    new: 'Create new transportation period',
    noneSelected: 'No transportation period filter',
    dateRangeOverlap: 'The date range must not overlap with an existing transportation period.',
    selectValidFrom: 'Set valid from to the global date.',
    selectValidUntil: 'Set valid until to the global date.',
    helpInfoText:
      'The transportation period filters the student list using the dates in the fields: Transportation from and Transportation until.',
  },
  validFrom: 'valid from',
  validUntil: 'valid until',
  from: 'from',
  toLaterThanFrom: 'The End must not be earlier than the Start.',
  create_tour: 'create Tour',
  search: 'Search...',
  new: 'New:',
  send_successful: 'send successfully',
  send_failed: 'send failed',
  send_delete_failed: 'send delete failed',
  CREDIT_LIMIT_EXCEEDED: 'The credit limit is exceeded.',
  STUDENT_DOES_NOT_FIT:
    'The student cannot be added because the student does not fit in tour because of capacity of the vehicle, tour type and grouping property of given school hours .',
  created_at_date_time: 'creation date and time',
  imported: 'imported',
  waiting_for_result: 'waiting for result',
  customTransportationPlaceForToursWithoutStudents:
    'Transportation place for tours without students',
  customTargetTimeForToursWithoutStudentsSelect: 'Select target time for special tours',
  targetTime: 'Target time',
  dayOfWeek: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  },
  check: {
    successful: 'finished successfully',
    last_run: 'last check',
  },
  config: {
    config: 'Configuration',
    minutes: 'minutes',
    minutesShort: 'min',
    inMinutes: 'in minutes',
    timeMatrix_config: 'boarding & disembarking tour config in seconds',
    timeMatrix_config_entry: 'boarding times config',
    timeMatrix_config_exit: 'disembarking times config',
    timeMatrix_recalculation_info:
      'Changes to boarding and disembarking times only take effect for existing tours after the tours have been recalculated via the context menu.',
    default_more_than_8_students: 'boarding time for more than 8 students',
    default_more_than_8_students_boarding_to: 'boarding-time TO-tour',
    default_more_than_8_students_disembarking_to: 'disembarking-time TO-tour',
    default_more_than_8_students_boarding_from: 'boarding-time FROM-tour',
    default_more_than_8_students_disembarking_from: 'disembarking-time FROM-tour',
    timeMatrix_config_seconds: 'Time in seconds',
    credit_limit_exceeded: 'Your credit limit is exceeded.',
    credit_limit_status_description_month: 'Current status of your credits for the current month',
    credit_limit_status_description_day: 'Current status of your credits for the current day',
    credit_limit: 'Credit-limit',
    credits_exceeded: 'Exceeded Credits',
    credits_used: 'Used credits',
    credits_remaining: 'Remaining credits',
    bulk_update_value_timeMatrix: 'Overwrite all values',
  },
  provide_information: 'field required',
  cost_area: 'Cost area',
  costcenter: 'Cost center',
  cost_provider: 'Cost provider',
  pedestrian: 'Pedestrian',
  addStudentsToExtraTour: 'Add students to extra tour',
  addStudentsToExtraTourDialog: {
    popUpOpenTitle: 'Add multiple students to a selected extra tour',
    firstStep: 'Select a date for the extra tour',
    firstStepInfo: 'All extra tours for the specified date will be loaded.',
    secondStep: 'Select a destination',
    secondStepInfo: 'Please select a destination for the selected students:',
    thirdStep: 'Add students to the selected extra tour',
    thirdStepInfo: 'To add students, please select one of the following extra tours:',
    stepper: {
      openTempTourDialog: 'Show temp tours',
      next: 'next step',
      back: 'back',
    },
  },
  student: {
    singular: 'student',
    singularAbbreviated: 'pers.',
    plural: 'students',
    gender_MALE: 'student(m)',
    gender_FEMALE: 'student(f)',
    gender_DIVERS: 'student(d)',
    new: 'new student',
    remove: 'Remove student',
    customTransportationPlace: 'Custom transportation-place',
    customTransportationPlaceIsDefault: 'custom transportation place is standard',
    defaultTransportationPlace: 'default transportation-place',
    changingDefaultTransportationPlaceHint:
      'changed default transportation place will be set to events form {{date}} on and student will be removed from all tours',
    changingDefaultTransportationPlaceHintPlural:
      'changed default transportation place will be set to events form {{date}} on and students will be removed from all tours',
    changingCustomTransportationPlaceHint:
      'An additional custom transportation place can be selected here.',
    changingSchoolHint:
      'student will be removed from {{date}} on from all tours and must be planned manually',
    detail: 'view of student',
    school_select: 'select all students in class: ',
    school_select_helper: 'please select all students in class and save',
    studentsOfTransportationModelId: 'students of standard week with ID: ',
    studentsOfSchoolId: 'students of school with ID: ',
    studentsWithTransportationNeed: 'students with transportation need',
    studentsFromTourSchoolId: 'students from tour with ID: ',
    studentsFromSelectedTours: 'students from selected tours',
    changes: {
      noCostAreaSelected: 'no cost area',
      noCostCenterSelected: 'no cost center',
      noCostProviderSelected: 'no cost provider',
      noKreisSelected: 'no administrative district',
      noJustificationSelected: 'no justification',
      noLotSelected: 'no lot',
      noMobilitySelected: 'no mobility',
      noSchoolSelected: 'no school',
      noTransportationModelSelected: 'no standard week',
      editTransportationModelInList: 'Edit in the student list',
      noUtilitySelected: 'no utilities for transport',
    },
    mobilitySettings: 'Mobility settings',
    list: 'list of all students',
    add_tour: 'add new student to tour',
    add: 'add student',
    birthday: 'Birthday',
    parent: 'Parent',
    parents: 'Parents',
    first_name_parent_1: 'First name 1. Parent',
    last_name_parent_1: 'Last name 1. Parent',
    first_name_parent_2: 'First name 2. Parent',
    last_name_parent_2: 'Last name 2. Parent',
    wheelchairSitting: 'Wheelchair,sitting',
    mobility: 'Mobility',
    utility: 'Utilities for transport',
    justification: 'Justification',
    employeeNumber: 'Student number',
    schoolClass: 'School class',
    schultraeger: 'School authority',
    feststellungsbescheidValidUntil: 'Assessment notice valid until',
    foerderschwerpunkt: 'Special educational focus',
    instructions: 'Instructions in timetable',
    additionalInformation: 'Short note',
    escortInBus: 'escort in bus',
    escortInBusTooltip:
      'For the escort in bus, exactly one seat is kept reserved for all passengers.',
    escortIndividual: 'escort individual',
    interkommLastenausgleich: 'Interkommunaler Lastenausgleich',
    interkommunalerLastenausgleichBafoeg: 'BAföG',
    interkommunalerLastenausgleichKindergarten: 'Kindergarten',
    interkommunalerLastenausgleichKreis: 'Administrative district',
    escortIndividualTooltip:
      'For the escort individual, for each passenger one seat is kept reserved. ',
    escortTooltipHint:
      'The escorts are not added automatically to the tours but need to be added manually in a second step.',
    handToHand: 'Hand to hand',
    tour_list: 'List of tours from student',
    tourPlan_list: 'List of plannings from student',
    transportationNeedFulfilled: 'Transportation need is fulfilled!',
    transportationNeedNotFulfilled: 'Transportation need is not (completely) fulfilled!',
    transportationNeedUnknown: 'Transportation need is not up to date!',
    transportationNeedFulfilled_description: 'Is transportation need fulfilled',
    transportationNeed: 'transportation need',
    deleteStudentSingular: 'Do you want to delete this student ?',
    deleteStudentPlural: 'Do you want to delete these students ?',
    deleteErrorHintSingular:
      'In case there are no future tours, the student will not be shown from tomorrow an',
    deleteErrorHintPlural:
      'In case there are no future tours, the students will not be shown from tomorrow an',
    deleteStudentFailedSingular: 'Deleting student impossible as student is planned',
    deleteStudentFailedPlural:
      'Deleting students impossible as the following students are planned: ',
    deleteErrorSingular: 'Error deleting student',
    deleteErrorPlural: 'Error deleting students',
    updateError: 'Error updating student',
    updateErrorTourIdConflict:
      'The tour {{tourId}} is between {{from}} and {{until}} in conflict with the changes. Please modify the tour and try again.',
    updateErrorTransportDate:
      'The relevant tours are split up and the student is scheduled according to the newly selected transport period. Please confirm.',
    updateDateMustBeMonday: 'Changedate needs to be monday when changing the school',
    outsideSelectedTransportationPeriod:
      'No data can be loaded for this student in the selected transportation period. Please select a different transportation period.',
    waitingForResult:
      'The update is in progress. This can take a few minutes. Please wait and do not close the dialog.',
    tour: {
      tours_of_selected_student: 'show selection for students',
      select_students_from_geocoded:
        'Tour planning for the current selected students cannot be started, because the following students are not uniquely geocoded:',
    },
    goToSchoolDetail: 'Go to school detail',
    attributes: 'Attributes',
    editInfoAttributes: 'edit attributes',
    noAttributesSelected: 'No attributes selected.',
    dateMustBeMonday: 'The date must be set to a Monday when adjusting the standard week or school',
    validFromWasUpdated: 'The "Valid from" date has been updated',
  },
  application: {
    titlePlural: 'Applications',
  },
  studentApplication: {
    title: 'Student applications',
    detail: 'Student application',
    firstName: 'First name',
    lastName: 'Last name',
    birthday: 'Date of birth',
    emailAddress: 'Email Address',
    phone: 'Phone number',
    schoolClass: 'School class',
    school: 'School',
    parentLastName: 'Last name of parent',
    parentFirstName: 'First name of parent',
    applicationForCurrentTransportationPeriod: 'Application for current transportation period',
    applicationForNextTransportationPeriod: 'Application for next transportation period',
    withUtilityDevice: 'With utility device',
    utility: 'Utility device',
    wheelchairTransportationRequired: 'Wheelchair support',
    additionalNotes: 'Additional notes',
    studentAddress: 'Student address',
    parentAddress: 'Parent/Guardian address',
    editedByUserName: 'Edited by user',
    isApprovedByUser: 'Application accepted',
    deleteStudentApplications: 'Do you want to delete these applications?',
    comparison: {
      popUpOpenTitle: 'Approval and merge',
      studentApplicationAttributes: 'Student attributes of application',
      studentAttributes: 'Student attributes already in system',
      NO_MATCH: 'There was no duplicate found',
      SINGLE_MATCH: 'There is one duplicate found',
      MULTIPLE_MATCHES: 'There are multiple matches. Please check the displayed students.',
      additionalAttributes: 'Do you want to accept more specific attributes? ',
      documents: 'Merge documents',
      comments: 'Merge additional comments',
      saveAttributes: 'Save selected attributes',
    },
    stepper: {
      studentStatus: 'Please choose a date for the duplicate check:',
      chooseAttributes:
        'Please choose one attribute of the corresponding lists of the student application and the student in the system:',
      chooseAttributesWithoutDuplicate: 'Please choose attributes for creating a new student:',
      next: 'Next',
      back: 'Back',
      error: 'An error occurred while loading a student.',
      startDuplicateCheck: 'Start check',
      chooseDateForCheck: 'You have to choose a date for the duplicate check.',
      noDuplicateFound:
        'No duplicates found. In the following steps you can create a new student with the attributes of the student application.',
      createNewStudent: 'Do you want to create a new student from the application?',
      noAddressFound: 'You did not choose an address to geocode.',
      geocodeInfo:
        'You can geocode the selected address. If the student has already a transportation place ' +
        'or is in any tour, the transportation place will be saved for the student. If the geocoding is not with a unique result ' +
        'we do not create a new transportation place.',
      approveApplication: 'Approve student application',
      finalApprovalInfo:
        'If you approve this student application, a new student will be created or updated. The changes for the updated student are valid ' +
        'from the date which was chosen in the first step. The application of the student will be set to approved.',
      ONE_foundDuplicates: 'Found duplicates',
      TWO_approvalOfAttributes: 'Approval and merge of attributes',
      THREE_geocodingAddress: 'Geocode address',
      FOUR_finalApproval: 'Final approvement',
    },
  },
  school: {
    singular: 'School',
    id: 'School ID',
    plural: 'Schools',
    new: 'new school',
    deleteSchoolSingular:
      'Do you really want to delete this school along with the associated students and tours?',
    lessons_show: 'show lessons',
    print_bill: 'print bill',
    hours: 'Transportation times',
    maxWaitingTime: 'max. waiting period',
    maxTransportationTime: 'max transportation period',
    minutesBeforeSchoolHour: 'Min. before school start/after end',
    config: 'School basic configuration',
    color: 'Color',
    schoolAuthority: 'school authorities',
    schoolDeletionEntities: {
      studentIdsOneSchool: 'Number of students with one school: ',
      studentIdsTwoOrMoreSchool: 'Number of students with more than one school: ',
      tourIds: 'Number of tours:',
      plannedTourIds: 'Number of plannings:',
      specialTourIds: 'Number of special tours:',
      extraTourIds: 'Number of extra tours:',
      entityDocumentIds: 'Number of documents:',
      transportFreeDaysIds: 'Number of vacation days:',
      placeIds: 'Number of places:',
      amountTours: 'Number of tours:',
      amountStudents: 'Number of students:',
      amountDocuments: 'Number of documents:',
      infoText:
        'Please note that all tours with the selected school will be deleted. Students with more than one school will not be deleted.',
    },
    tour: {
      tours: 'tours of school',
      tours_planned: 'plannings of school',
      tours_of_selected_school: 'show selection for schools',
    },
    student: {
      students: 'Students of school',
    },
    schoolHour: {
      name: 'Description',
      grouping: 'Cross-facility grouping',
      groupingHint: 'Enables joint pickup of nearby facilities with similar transportation times.',
      time: 'Time',
      readOnly: 'Transportation times that are already in use cannot be changed or deleted',
      TO: 'Outward',
      FROM: 'Return',
      TRANSFER: 'Transfer',
      targetPlace: 'Target place',
      startPlace: 'Start place',
      saveHint: 'Please click save button to save the changes',
    },
    error: {
      no_tours_planned: 'No tours were planned.',
    },
  },
  schoolcenter: {
    singular: 'school center',
    plural: 'school centers',
    new: 'new school center',
  },
  address: {
    label: 'Address',
    street: 'Street',
    house_number: 'House number',
    extension: 'Extension',
    district: 'District',
    postal_code: 'Postal Code',
    city: 'City',
    place_type: 'Place Type',
    copy_parent: 'copy address data into parent address',
    geocoding: 'Geocoding',
    geocoding_dialog: 'Addresse and Geocoding',
    geocoding_result: 'Result',
    geocoding_results: 'Results',
    geocoding_selected: 'Selected',
    geocoding_state: 'geocoded',
    geocoding_state_false: 'Current address is not geocoded',
    geocoding_state_description: 'Could the current address be geocoded?',
    geocoding_save: 'Save geocoded place',
    geocoding_error: 'Error while geocoding an address',
    no_geocoding_result: 'No results',
    mappedEntities: 'mapped objects',
    coordinatesChanged: 'Coordinates changed',
    coordinatesUnChanged: 'Coordinates unchanged',
  },
  jobs: {
    notfications: 'Notifications',
    you_have: 'You have ',
    unread_messages: ' Notifications',
    read_messages: ' messages',
    mark_all_read: ' Hide all',
    personalizedNotifications: 'Show only personal notifications',
    unreadNotifications: 'Show only new notifications',
    view_all: 'View all',
    sent: 'Job sent',
    error_sending: 'Error sending a job',
    imported: 'imported',
    issue: 'not imported',
    refresh: 'Refresh notifications',
    errorIgnoreSchedule:
      'plannings are selected, which were planned without respecting the standard week.',
    notification: {
      period: 'Period: ',
    },
  },
  tours: {
    singular: 'Tour',
    plural: 'Tours',
    new: 'new tour',
    detail: 'view of tour',
    calculate: 'recalculate',
    id: 'ID Parts of tour',
    days: 'days of tour',
    days_group: 'split / divide by days',
    splitTourHelp:
      'The tour can either be split at the selected date or divided by tour days. Unselected tour days will be removed.',
    cloneAsPlannedTour: 'Plan again',
    cloneAsPlannedTourTooltip:
      'Plan again with the same people and the same tour days. Attributes will not be copied. The tour will be created as a planning.',
    new_day_group: 'new group',
    to: 'to',
    show_in_map: 'show in map',
    show_all_in_map: 'Show in map',
    highlight_in_map: 'Highlight in map',
    unhighlight_in_map: 'Remove highlight from map',
    highlight_all_selected_in_map: 'Highlight all selected tours in map',
    generated: 'were generated',
    not_generated: 'No ',
    tourFetchingType: 'Tour or planning',
    considerDailyValidity: 'consider day of the week of selected date',
    occupiedDistance: 'Occupied kilometre ',
    isPlannedTours: 'Is plannings',
    regular: 'Regular',
    daySpecific: 'Day specific',
    amountOfStudentsInTour: 'Amount of students in tour',
    studentNamesOfTour: 'Students of tour',
    studentNamesOfSelectedTours: 'Students of selected tours',
    daysFilter: 'Days of tour filter',
    daysFilterEmpty: 'Select days to filter tours by transportation times.',
    tourListWithoutDateConsideration: 'Show all tours',
    globalDateIgnoredHint:
      '"Show all tours" is active: all tours are shown regardless of their validity period. ' +
      'The globally selected date does not apply to this list and is therefore disabled in the ' +
      "header. Time-dependent attributes are loaded on each tour's first day of validity.",
    globalDateIgnoredByFilterHint:
      'Because of the active tour preselection all tours are shown regardless of their validity ' +
      'period. The globally selected date does not apply to this list and is therefore disabled ' +
      "in the header. Time-dependent attributes are loaded on each tour's first day of validity.",
    showExtendedAttributes: 'Expand tour list',
    extendedAttributesInfo: 'Customize tour list',
    extendedAttributesTooltip:
      'Enables the display of extended attributes in the tour list. This includes additional information ' +
      'such as custom tour attributes, extended time and distance calculations, and other specific tour properties.',
    tourListWithoutDateConsiderationTooltip:
      'Disables filtering by the global date and displays all tours regardless of their validity ' +
      "period. Time-dependent attributes are loaded on each tour's first day of validity. " +
      'This is helpful when you need a complete overview of all existing' +
      ' tours without restriction by the globally selected date.',
    considerDailyValidityTooltip:
      'Considers the daily validity of tours based on the currently selected global date. ' +
      'When enabled, only tours scheduled for the corresponding weekday (e.g., Monday, Tuesday) are displayed.',
    overcrowded: 'overcrowded',
    plannedWithCustomTransportationPlace: 'Planned with custom transportation place',
    totalStudents: 'Total students',
    pendingNotification: {
      base: 'The tours are currently calculated. ',
    },
    minutesAroundSchool: 'minutes before school-start/after school-end at tour',
    minutesAroundSchoolTOTour: 'minutes before school-start',
    minutesAroundSchoolFROMTour: 'minutes after school-end',
    optimizeOrder: 'Optimize order',
    optimizeOrderTooltip:
      'When enabled, the order of stops will be automatically optimized when adding students',
    tender: {
      title: 'tour tender',
      selectTourOrTourBundle: 'select tours or tour-bundles',
      parametersAndLayout: 'settings of parameters and layout',
      parameters: 'parameter settings',
      firstPage: '1. page - detailed description',
      lastPage: 'last page offer form',
      tourServiceOfferText: 'offer text',
      header: 'header',
      headerTitle: 'title for tour-tender of tours/planned-tours',
      headerContentServiceName:
        'service name (same as tour-bundle-names, for tour/planned-tours retrieve from text-field)',
      headerContentSchoolName: 'schools',
      headerContentLogo: 'customer-logo',
      tenderType: 'tender-type',
      headerValidity: 'validity',
      serviceDescription: 'description',
      tourService: 'tour service',
      tourServiceContentHeader: 'header with weekday, time and tour-ame',
      tourServiceContentHeaderTourNumber: 'header with tour-number',
      tourServiceContentSchools: 'addresses of schools',
      tourServiceContentEscortPersonal: 'count escort personal and wheelchairs',
      tourServiceContentOccupiedValues: 'occupied time and distance',
      stopsList: 'list of stops',
      stopsListPostalCodeCity: 'postal-code and time',
      stopsListCountStudentsAtStop: 'count of students at stop',
      stopsListPostalStreet: 'street of stop',
      stopsListPostalStreetHouseNumber: 'street with house-number',
      stopsListSchoolClass: 'school-class',
      stopsListYearOfBirth: 'year of birth',
      stopsListUtility: 'utilities',
      stopsListMobility: 'mobilities',
      stopsListShortNote: 'short note',
      showServiceDescription: 'show service description',
      showTourNumber: 'show tour number',
      showStudentSchoolClass: ' show school-class',
      showStudentHouseNumber: 'show street with house-number',
      showStudentYearOfBirth: 'show year of birth',
      showStudentUtility: 'show utilities',
      showStudentMobility: 'show mobilities',
      showStudentShortNote: 'show short-notes',
      headerBidderSchools: 'school-names',
      bidderStandardText: 'default offer-text',
      offerDetailMatrix: 'offer-details',
      biddingFormDescription: 'information text for bidder',
      showBiddingFormDescription: 'show information-bidder-text',
      bidderInformation: 'contact field bidder',
      showBidderInformation: 'show contact field bidder',
      bidderInformationContent: 'name, street, house-number, postal-code, place, phone, email',
      bidderSignatureField: 'signature field for bodder',
      bidderSignatureFieldContent: 'place, date, signature',
      saveAndSend: 'save and send',
      defaultTimes: 'default times',
      defaultTOArrivalTourTime: 'default TO-tour arrival time',
      defaultFROMDepartureTourTime: 'default FROM-tour departure time',
      defaultTimeExplanation:
        'If a tour is planned without transportation-group, those default times will be printed out in the export',
      showStudentHouseNumberInRange: 'show house-number in range',
      showStudentName: 'show student name',
      studentHouseNumberInRange: 'house-number in range (e.g: Maierstr. 7 = Maierstr 0-10)',
      studentName: 'name of student',
      sameAsServiceDescription: 'same as service-description',
    },
    errorNotification: {
      base: 'Error while generating new tours. ',
      base_change: 'Error while changing an existing tour',
      no_tours_planned: 'No tours were planned.',
      no_transportationModel: 'The students have no standard week.',
      no_weekday_with_demand: 'There is no transportation demand on any of the selected weekdays.',
      tour_loading_error:
        'Error loading the tour data: The selected date is outside the validity period of the tour.',
      NO_PLANNED_TOUR_FOUND: 'No planned tour was found for this ID.',
      TOUR_VEHICLE_OVERCROWDED:
        'The vehicle assigned to the planned tour is over capacity, so the tour cannot be converted.',
      status: {
        'Internal Server Error': 'An internal server error occurred.',
        ALREADY_IN_TOUR: 'The student is already assigned to this tour.',
        STUDENT_ALREADY_IN_TOUR: 'The student is already assigned to a tour.',
        LAST_STUDENT_IN_TOUR: 'The tour contains only this student.',
        INSUFFICIENT_REGULAR_SEATS:
          'The vehicle does not have enough regular seats for the student and required escorts.',
        INSUFFICIENT_WHEELCHAIR_SEATS:
          'The vehicle does not have enough wheelchair seats for the student.',
        MISSING_CALENDAR_EVENTS:
          'The student has no calendar events on at least one day when the tour operates.',
        INCOMPATIBLE_SCHEDULE:
          'The student schedule groupings are not compatible with the tour school-hour groupings.',
        NO_SEATS_AVAILABLE:
          'There are no available seats in the vehicle. Please also check the number of available wheelchair spaces.',
        NO_WEEKDAY_WITH_DEMAND: 'There is no demand on the requested weekdays.',
        TOO_MANY_VEHICLES_IN_FLEET: 'There are too many vehicles in the fleet.',
        NUMBER_OF_CUSTOM_PROFILES_EXCEEDED:
          'The maximum number of custom routing profiles has been exceeded.',
        UNEQUAL_TO_AND_FROM_TOURS: 'There is an inconsistency in the number of to and from trips.',
        NO_BOARDING_STOP_IN_TOUR: 'No boarding stop was found for the tour.',
        NO_DISEMBARKING_STOP_IN_TOUR: 'No disembarking stop was found for the tour.',
        GENERIC_ERROR: 'A general error has occurred.',
        ERROR: 'An error occurred. Please contact support.',
        TIME_LIMIT_EXCEEDED: 'Tour planning or routing could not be completed within 60 minutes.',
        REQUEST_QUEUE_ERROR: 'An error occurred while processing multiple jobs.',
        NO_ROUTES_FOUND: 'No routes could be calculated.',
        NO_TOURS_FOUND: 'No tours were found.',
        SECTIONS_EXCEED_NUMBER_OF_STOPS:
          'The number of segments exceeds the number of stops. Please contact support.',
        GEOTRANSFORMATION_ERROR:
          'An error occurred during geodata transformation. Please contact support.',
        MAX_DAYS_FOR_TOUR_INSTANCE_CALCULATION_EXCEEDED:
          'The maximum number of days for calculating daily tours has been exceeded. ' +
          'By default, up to 31 days can be calculated. Terraplan can adjust this limit.',
        STUDENT_ALREADY_IN_OVERLAPPING_TOUR:
          'The student is already scheduled in a tour for the selected time period.',
        INCOMPATIBLE_TRANSPORTATION_PERIOD:
          'The selected date is outside the student transportation period.',
        NO_ORIGINAL_TOUR_IN_HOLDER: 'The selected tour is currently not available.',
        CREDIT_LIMIT_EXCEEDED: 'The credit limit has been exceeded. Please contact support.',
        MAX_TIME_IN_VEHICLE_CONSTRAINT:
          'You cannot add the student because this would exceed the maximum transportation ' +
          'time. Note: You can edit the maximum transportation time in the school administration ' +
          'and then add the student to the tour.',
        TIME_WINDOW_CONSTRAINT:
          'The student cannot be added because a specified time window cannot be met. ' +
          "In particular, check the affected school's maximum waiting time as well as the " +
          'pickup and vehicle operating times.',
        VEHICLE_TYPE_NOT_DEFINED:
          'Please check if every used vehicle has an assigned vehicle type.',
        TOUR_CLASS_COST_FEE_NOT_DEFINED:
          'Please check whether the time-category price matrix contains prices for all used ' +
          'vehicle types and cost types.',
        TRANSPORTATION_COMPANY_NOT_DEFINED:
          'The price-sheet export was cancelled because at least one vehicle actually used has ' +
          'no transportation company assigned. Please check the vehicle master data.',
        SCHEDULE_NOT_SUITABLE:
          "Please check the student's calendar. No matching calendar events were found for at least one tour day.",
        STUDENT_DOES_NOT_FIT:
          'The student cannot be added because of the vehicle capacity, tour type, grouping, ' +
          'or specified transportation times.',
        NO_SCHEDULE:
          'Please check the student calendar. No events could be found ' +
          'at the time of the change.',
      },
      overlappingToursInfo:
        'Student {{studentId}} is already assigned to {{count}} overlapping tour(s) on {{date}}:',
      viewTour: 'View tour',
      details: {
        studentId: {
          singular: 'student ID',
          plural: 'student IDs',
        },
        tourId: 'Tour ID',
        validAt: 'Validation date',
        transportFrom: 'Transportation from',
        transportUntil: 'Transportation until',
        transportationPeriodIncompatibility: 'Outside the transportation period',
        incompatibleDay: 'Incompatible day',
        tourGroupings: 'Tour groupings',
        studentGroupings: 'Student groupings',
        availableSeats: 'Available seats',
        requiredSeats: 'Required seats',
        availableWheelchairSeats: 'Available wheelchair seats',
        requiredWheelchairSeats: 'Required wheelchair seats',
        needsWheelchair: 'Needs wheelchair seat',
        needsIndividualEscort: 'Needs individual escort',
        needsBusEscort: 'Needs bus escort',
      },
      transportationPeriodCompatibilityStatus: {
        COMPATIBLE: 'Within the transportation period',
        BEFORE_TRANSPORT_FROM: 'Before transportation start date',
        AFTER_TRANSPORT_UNTIL: 'After transportation end date',
      },
    },
    route_passengers: 'route and stops',
    overview: 'Overview',
    edit: 'edit tour',
    validityOutsideGlobalDate:
      'selected global date outside of tour validity - no daily data can be shown',
    add_student: 'add student',
    add_mandatory_routing_point: 'add mandatory routing point',
    addStudentFiltered: 'add student (only suitable students displayed)',
    studentSwitchFilter: 'Filter Suitable Students',
    addStudentWithPlaceInfo:
      'The selected location will be stored as a pickup or departure place in the extra tour for the added student. The extra tour will be recalculated after saving.',
    addMandatoryRoutingPointPlaceInfo:
      'The selected place will be added as a mandatory stop in the existing tour. When the location is applied, the tour will be recalculated.',
    tourType: {
      type: 'To/From',
      TO: 'outward journey',
      FROM: 'return journey',
      TRANSFER: 'transfer',
      EXTRA: 'extratour',
      TRANS_MODEL_TO_DEVIATION: 'deviation outward',
      TRANS_MODEL_FROM_DEVIATION: 'deviation return',
      DEVIATION: 'no tours at day',
      VACATION: 'vacation',
      OTHER: 'not defined',
      abbreviation: {
        TO: 'T',
        FROM: 'F',
        TRANSFER: 'T',
        OTHER: 'O',
      },
    },
    tourReason: {
      reason: 'Reason',
      TRANSPORTATION_MODEL: 'standard week',
      DEVIATION: 'Deviation',
      EXTRA_TOUR: 'Extra Tour',
      SPECIAL_TOUR: 'Special Tour',
      IGNORE_SCHEDULE: 'standard week ignored',
    },
    tourInMap: {
      id: 'tour-Id',
      attributes: 'attributes',
      type: 'tour-type',
      empty_segment: 'empty segment',
      normal_segment: 'tour segment',
      departure: 'departure place',
      arrival: 'arrival plce',
      time: 'duration',
      distance: 'distance',
      meter: 'meter',
      tourId: 'tour-id',
      allStudents: 'Alle Studenten',
      allSchools: 'Alle Schulen',
    },
    plan: {
      plural: 'plannings',
      singular: 'planning',
      detail: 'view of planning',
      dialog: 'Plan tours',
      dialogSchools: 'Plan tours without students',
      dialogFROMTours: 'plan FROM-tours',
      deletedPlural: 'plannings deleted',
      customTransportationPlaceHint:
        'consider students custom transportation place or address for tour-planning. If no custom transportation place is present, use the student`s address',
      customTransportationPlaceHintPlural:
        'consider custom transportation place for students for tour-planning. If no custom transportation place is present, use the students default transportation place',
      changingCustomTransportationPlaceHint:
        'If required, a custom transportation place can be passed. If none is selected, only the change of the default transportation place will be saved',
      tourType: 'Tour type',
      algorithm: 'Algorithm',
      vehicleType: 'Vehicles',
      to: 'outbound',
      from: 'return',
      fromTransportationPlace: 'Endpoint is school',
      toTransportationPlace: 'Endpoint is transportation place',
      algorithmSame: 'like outbound',
      algorithmGroupPriority: 'keep student groups',
      algorithmScheduleAware: 'respect schedules',
      algorithmIgnoreSchedule: 'ignore schedules',
      algorithmOptimal: 'optimal',
      vehicleTypes: {
        AVAILABLE: 'available fleet',
        IMPLICIT: 'virtual fleet',
        EXPLICIT: 'select from list',
      },
      ignoreVehiclePlaces: 'Ignore vehicle place',
      planning: 'Start planning',
      select_only_from_tours: 'please select only from-tours',
      errorDateRange: 'Please select a valid date range',
      transform: 'transform plan into tours',
      vehiclePlaceType: 'Vehicle place type',
      vehiclePlaceTypes: {
        DEFAULT: 'Vehicle default place',
        EXPLICIT: 'Selected place',
        TRANSPORTATION_COMPANY: 'Transportation company',
      },
      scheduleAwareHint:
        'the days, name, validity and students are retrieved from the selected tours',
      hintCalenderWeek: 'The tours are planned based on the calendar entries in CW {{weekNumber}}.',
      hintCalenderWeekExplanation:
        'The planning basis is the first week of the selected period. ' +
        'The calendar entries of the first week are used to plan the tours. ' +
        'Calendar entries from subsequent weeks that differ from the first week are not considered at this point.',
      reserveSeatForBusEscort: 'reserve 1 seat for bus escort',
      calculationMethod: 'Optimize by',
      shortestTime: 'Time',
      shortestDistance: 'Distance',
      planFromTours: 'Plan return tours automatically',
      tourPlanningWizard: 'Plan return tours manually',
    },
    transform: {
      title: 'Result tour transformation',
    },
    no_boarding: 'no boarding at this stop',
    no_disembarking: 'no disembarking at this stop',
    duration: 'duration',
    students_do_boarding: 'students get boarded at this stop',
    students_do_disembarking: 'students get disembark at this stop',
    students_unassigned: "students couldn't be assigned to a tour",
    unassignedReasonUnknown: 'Unknown reason (GraphHopper code {{code}})',
    unassignedType: {
      UNKNOWN: 'Unknown',
      SKILL_CONSTRAINT: 'Vehicles cannot serve required skill. ',
      TIME_WINDOW_CONSTRAINT:
        'The time window for the planning is insufficient. ' + 'Please contact the support',
      CAPACITY_CONSTRAINT: 'Does not fit into any vehicle due to capacity. ',
      MAX_JOB_CONSTRAINT: 'Does not fit into any vehicle due to capacity. ',
      MAX_DISTANCE_CONSTRAINT: 'The job location is too far away. ',
      NO_TRANSPORTATION_NEED: 'No transportation need.',
      NO_REASON_FOUND: 'Could not be planned with undefined reason. ',
      REACHABLE_CONSTRAINT:
        'The location is not reachable for the vehicle(s) due to live traffic conditions. ',
      SHIFT_TIME_CONSTRAINT: "The vehicle's shift time is insufficient to serve more jobs. ",
      RELATION_CONSTRAINT: 'Could not be scheduled due to assignment or sequencing constraints. ',
      ALLOWED_VEHICLE_CONSTRAINT: 'Could not be assigned due to allowed vehicle constraint. ',
      MAX_TIME_IN_VEHICLE_CONSTRAINT:
        'You cannot add the student because this would exceed the' +
        ' maximum transportation time.' +
        'Note: You can edit the maximum transportation time in the school administration ' +
        'and then add the student to the tour. ',
      BREAK_NOT_REQUIRED: 'The driver does not need a break. ',
      DISALLOWED_VEHICLE_CONSTRAINT:
        'Could not be assigned due to a disallowed vehicle constraint. ',
      MAX_DRIVE_TIME_CONSTRAINT: 'Could not be assigned due to the maximum drive time constraint. ',
      MAX_ACTIVITY_CONSTRAINT: 'Could not be assigned due to the maximum activity constraint. ',
      GROUP_RELATION_CONSTRAINT:
        'Could not be scheduled because the constraints defined for its transport group' +
        ' could not be satisfied',
      DRIVING_TIME_BREAK_CONSTRAINT: 'Could not be assigned due to a required driving time break. ',
      LOCATION_NOT_ACCESSIBLE_CONSTRAINT:
        'The location cannot be accessed over the road network by every vehicle. ',
      LOCATION_ISOLATED_CONSTRAINT:
        'The location is isolated and cannot reach another location over the road network. ',
    },
    tourDetail: {
      studentCount: 'count students',
      stopsCount: 'count stops',
      wheelchairCount: 'count wheelchair',
      freeSeats: 'free seats in vehicle',
      freeWheelchairSeats: 'thereof free whelchair seats in vehicle',
      individualEscortCount: 'count individual escort',
      studentWithWheelchairCount: 'count students with wheelchair',
      utilities: 'utilities',
      routingMethod: 'routing-method',
      plannedWithCustomTransportationPlace: 'planned with custom transportation place',
      duration: 'duration',
      costsPlannedState: 'prices',
      costHistory: 'price history',
      costs: 'costs',
      distance: 'distance',
      number: 'number',
      numberHint: 'tournumber cannot be used for plannings',
      abbreviation: 'abbreviation',
      validityPeriod: 'validity period',
      virtualVehicle: 'virtual vehicle',
      virtualDriver: 'virtual driver',
      noDriver: 'no driver',
      missing: 'is missing in tour at',
      additional: 'is added to tour at',
      noDeviation: 'no deviations present',
      delete_tour: 'Do you want to delete this {{tour}}?',
      emptySections: 'empty sections',
      emptySectionsVirtualVehicleHint:
        'Empty sections cannot be assigned to tours with a virtual vehicle.',
      emptyDistancePercentage: 'Empty distance percentage',
      timeline: 'connected tours',
      noTimeline: 'no connected tours present',
      km: {
        occupiedKm: 'occupied distance sum',
        emptyKmTO: 'empty distance to',
        emptyKmFROM: 'empty distance from',
        emptyKmSum: 'empty distance sum',
        kmSum: 'distance sum',
        placeEmptyTO: 'departure place',
        placeEmptyFROM: 'arrival place',
        overriddenOccupiedDistance: 'APV-Km',
      },
      time: {
        occupiedTime: 'occupied minutes',
        emptyTimeTO: 'occupied time to-segment',
        emptyTimeFROM: 'occupied time from-segment',
        emptyTimeSum: 'empty segments time sum',
        boardingSum: 'boarding time at all stops',
        disembarkingSum: 'disembarking time at all stops',
        waitingTime: 'waiting time',
        timeBeforeSchoolStart: 'arrival before school start',
        timeAfterSchoolEnd: 'departure after school end',
        timeSum: 'tour time sum',
        additionDriverWorkingTime: 'addition to driver working time',
        driverWorkingTimeSum: 'driver working time',
      },
      price: {
        occupiedCostPerKm: 'price per occupied km',
        emptyCostPerKm: 'price per empty km',
        costFlatRate: 'flat-rate',
        costAddition: 'addition',
        occupiedCostSum: 'costs occupied km',
        emptyCostSum: 'costs empty km',
        costSum: 'costs sum',
      },
      utilityOption: {
        utility_e_wheelchair_sitting: 'e-wheelchair seated',
        utility_e_wheelchair_movable: 'e-whelchair movable',
        utility_wheelchair_foldable: 'wheelchair foldable',
        utility_wheelchair_fixed: 'wheelchair fixed',
        utility_child_seat: 'child seat',
        utility_walker: 'walker',
        utility_seat_shell: 'seat shell',
        utility_other: 'other',
        utility_wheelchair_fixed_knot: 'fixed wheelchair with knot',
        utility_child_seat_fixed: 'child-seat 3-points fixing',
        utility_seat_raised: 'raised seat',
      },
      changedAttributes: {
        driver: 'show driver changes in tour validity',
        escort: 'show bus escort changes in tour validity',
        vehicle: 'show vehicle changes in tour validity',
        cost: 'show cost changes in tour valdity',
        emptySection: 'show empty-section changes in tour validity',
        changedVehicleHint:
          'by default the empty-sections places will be updated accordingly to the selected vehicle place',
        driverHistory: 'driver history',
        vehicleHistory: 'vehicle history',
        emptySectionHistory: 'empty sections history',
      },
      escortAssignment: {
        history: 'History of escort assignments',
        noEmployee: 'no employee',
        title: 'Escort employee',
        deleteDialogTitle: 'Do you really want to delete this entry?',
      },
    },
    list: {
      selected_tours: 'show selected tours',
      delete_tours: 'Do you want to delete these {{tour}}?',
    },
    tempTour: {
      seeGeneratedTempTours:
        'Please see the generated temp tours for adjustments you made on the Tour-ID {{id}}',
      originalTour: 'Original tour',
      allTempTour: 'New tours',
      noTempTour: 'No temporary tours generated. Please try again.',
      selectOneTempTour: 'Please select any one temporary tour!',
      showAllToursInMap: 'Show all tours in map',
      saveAllTempTours: 'Save all tours',
      discardAllTempTours: 'Discard all tours',
      stop: 'Stops',
      tempTour: 'Temporary tour',
    },
    rerouted_CURRENT: 'Tours recalculated using existing optimization',
    rerouted_SHORTEST_PATH: 'Tours recalculated using shortest path',
    rerouted_SHORTEST_TIME: 'Tours recalculated using shortest time',
    dateValidation: {
      dateOutsideTourRange:
        'The selected date is not within the tours validity period. ' +
        'If you want to make changes to the tour, please select a date within the validity period.',
    },
  },
  tourPlan: {
    name: 'tour plan',
  },
  tourBundle: {
    bundleName: 'Tour Bundle',
    bundle_create: 'Create Tour Bundle',
    bundleEdit: 'Edit Tour Bundle',
    bundleAdd: 'Add to Tour Bundle',
    description: 'Description',
    color: 'Color',
    singular: 'Tour Bundle',
    plural: 'Tour Bundles',
    new: 'New Tour Bundle',
    detail: 'Tour Bundle',
    list: 'List of all Tour Bundles',
    deleteTourBundles: 'Delete Tour Bundles',
    deleteConfirm: 'Do you want to delete this tour bundle?',
    deleteConfirmPlural: 'Do you want to delete these tour bundles?',
    deleteSuccess: 'Tour bundle successfully deleted',
    deleteError: 'Error deleting tour bundle',
    createSuccess: 'Tour bundle successfully created',
    createError: 'Error creating tour bundle',
    updateSuccess: 'Tour bundle successfully updated',
    updateError: 'Error updating tour bundle',
    tours: 'Tours',
    addTours: 'Add Tours',
    removeTours: 'Remove Tours',
    noTours: 'No tours in bundle',
  },
  file: {
    name: 'file name',
    format: 'file format',
    print_request_successful: 'your print request has been successful',
    pick_date_range: 'Select the range of date',
    pdf: {
      create: 'create PDF file',
      delete: 'delete PDF file',
    },
    excel: {
      create: 'create Excel file',
      delete: 'delete Excel file',
    },
  },
  our_calendar: {
    today: 'Today',
    event: 'calendar-event',
    add_event: 'New entry',
    edit_event: ' edit',
    event_type: 'Event type',
    VACATION: 'Holidays',
    TRANSPORTATION_MODEL: 'standard week',
    TRANSPORTATION_MODEL_DEVIATION: 'standard week deviations',
    TRANS_SCHEDULE: 'Ride',
    TRANS_MODEL_TO: 'Ride',
    TRANS_MODEL_FROM: 'Ride',
    TRANS_MODEL_TRANSFER: 'Transfer ride',
    departure_trans_schedule_from: 'From:',
    departure_trans_schedule_transfer: 'Transfer:',
    arrival_trans_schedule_to: 'To:',
    DEVIATION: 'Deviation',
    TRANS_DEVIATION: 'Ride deviation',
    TRANS_EXTRA_TOUR_TO: 'Extra tour (target time selectable)',
    TRANS_EXTRA_TOUR_FROM: 'Extra tour (start time selectable)',
    TRANS_MODEL_TO_DEVIATION: 'Ride',
    TRANS_MODEL_FROM_DEVIATION: 'Ride',
    TRANS_MODEL_TRANSFER_DEVIATION: 'Ride',
    TRANS_MODEL_TO_MANUAL: 'To-ride',
    TRANS_MODEL_FROM_MANUAL: 'From-ride',
    TRANS_MODEL_TRANSFER_MANUAL: 'Transfer ride',
    no_transport: 'All day no transportation',
    place: 'Place: ',
    WEEKLY: 'weekly',
    TWO_WEEKLY: '2-weekly',
    NONE: '',
    create_event_success: 'Event successfully created.',
    unavailability: {
      calendar: 'unavailability calendar',
      add_event: 'New entry unavailability',
      select: 'select cause',
    },
    recurrence_end_day: 'recurrende end day',
    recurrence: 'recurrence',
    title: 'title',
    start_date: 'start',
    end_date: 'end',
    start_time: 'start time',
    end_time: 'end time',
    deactivate_single_event: 'delete single event',
    deactivate_series: 'delete series of events',
    make_event_adjustment: 'deviation',
    year: 'Year',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    agenda: 'Agenda',
    undoDeviation: 'restore event',
    helpTextExtraEventRecurrence:
      'The extra tour is valid for for one tour day and until the recurrence end.',
    transportationModelInformation: 'This event is related to the standard week ',

    confirm_recurrenceEnd_change: 'Confirm recurrence end change',
    confirm_recurrenceEnd_change_message:
      'If you change the recurrence end date, all tours from the change date onwards will be adjusted. ' +
      'The student will no longer be transported on the weekday of the change. Are you sure you want to change the recurrence end date?',
    recurrenceEnd_date_changed: 'The recurrence end date has been changed.',
    recurrenceEnd_date_change_cancelled: 'The recurrence end date change has been cancelled.',
  },
  transportationCompany: {
    singular: 'transportation company',
    plural: 'transportation companies',
    new: 'new transportation company',
    contactPerson: 'contact person',
    selectAutomatically: 'Select automatically',
    virtual: 'Virtual fleet',
    tour: {
      tours: 'tours of transportation company',
      tours_planned: 'planned tours of transportation company',
      tours_of_selected_transportation_company: 'show selection for transportation companies',
    },
  },
  tourClassVehicleMatrix: {
    tabTitle: 'Time categories - Price matrix',
    title: 'Time Category Vehicle Type Matrix',
    singular: 'Matrix',
    plural: 'Matrices',
    new: 'Create New Entry',
    edit: 'Edit Entry',
    selectVehicleType: 'Please select a vehicle type',
    addedToList: 'Matrix added to list',
    noData: 'No entries available',
    allSavedSuccess: '{{count}} entries successfully saved',
    unsavedEntries: 'Unsaved entries',
    saveError: 'Error saving matrices',
    removedFromList: 'Matrix removed from list',
    deleteConfirm: 'Do you really want to delete this matrix?',
    deleteSuccess: 'Matrix successfully deleted',
    deleteError: 'Error deleting matrix',
    updateSuccess: 'Matrix successfully updated',
    updateError: 'Error updating matrix',
    vehicleType: 'Vehicle Type',
    matrixType: 'Matrix Type',
    tourClass: 'Time Category',
    costFee: 'Cost Fee',
    actions: 'Actions',
    addToList: 'Add to List',
    saveAll: 'Save All',
    unsavedChanges: 'Unsaved Changes',
    localList: 'Local List',
    existingMatrix: 'Existing Matrix',
    costType: 'Cost Type',
    types: {
      DRIVING_PERFORMANCE: 'Driving Performance',
      DRIVER: 'Driver',
      ESCORT: 'Escort',
    },
    infoDescription:
      'Here you can define a price matrix that stores cost fees for different time categories. ' +
      'Each matrix defines rates for a specific combination of vehicle type and cost type ' +
      '(driving performance, driver, or escort). The cost fees are indexed by time category, ' +
      'where time categories represent different duration ranges of tours. You can create ' +
      'an entry for each combination of cost type and vehicle type.',
    noTourClassTimesWarning:
      'Please create time categories first before creating entries for the matrix.',
  },
  tourClassTimes: {
    title: 'Definition of Time Categories',
    durationMin: 'Duration Min (Minutes)',
    durationMax: 'Duration Max (Minutes)',
    tourClass: 'Time Category',
    saveTimes: 'Save time categories',
    createTimes: 'Create new time categories',
    saveChanges: 'Save changes',
    unsavedChanges: 'You have unsaved changes',
    saveSuccess: 'Time categories successfully saved',
    saveError: 'Error saving time categories',
    validationError: 'Please check the entered values',
    class: 'Time Category {{number}}',
    reset: 'Reset',
    infoDescription:
      'Here you can define the time ranges for the different time categories. ' +
      'Each time category represents a time range for the tour duration. ' +
      'The ranges must be continuous and must not overlap.',
  },
  vehicleCostFees: {
    title: 'Vehicle Type Cost Flat Rate',
    new: 'New Vehicle Type Cost Flat Rate',
    edit: 'Edit Vehicle Type Cost Flat Rate',
    infoDescription:
      'If the number of vehicles is fixed, activate the option and set the value manually. ' +
      'If it is not fixed, the number of vehicles will be calculated automatically.',
    vehicleType: 'Vehicle Type',
    costFee: 'Vehicle Type Cost Flat Rate (€)',
    amountOfVehicles: 'Number of Vehicles',
    fixed: 'Fixed',
    amountOfVehiclesIsFixed: 'Amount of vehicles is fixed',
    selectVehicleType: 'Please select vehicle type',
    noData: 'No Vehicle Type Cost Flat Rates available',
    unsavedEntries: 'Unsaved entries',
    existingFees: 'Existing Vehicle Type Cost Flat Rates',
    addToList: 'Add to list',
    saveAll: 'Save all Vehicle Type Cost Flat Rates',
    addedToList: 'Added to list',
    removedFromList: 'Removed from list',
    noFeesToSave: 'No Vehicle Type Cost Flat Rates to save',
    allSavedSuccess: '{{count}} Vehicle Type Cost Flat Rates successfully saved',
    updateSuccess: 'Vehicle Type Cost Flat Rates successfully updated',
    updateError: 'Error updating Vehicle Type Cost Flat Rates',
    deleteConfirm: 'Do you really want to delete this Vehicle Type Cost Flat Rate?',
    deleteSuccess: 'Vehicle Type Cost Flat Rate successfully deleted',
    deleteError: 'Error deleting Vehicle Type Cost Flat Rate',
    saveError: 'Error saving Vehicle Type Cost Flat Rate',
    vehicleTypeAlreadyExists: 'The vehicle type has already been created',
    entityFee: {
      title: 'Vehicle Cost Flat Rate',
      new: 'New Vehicle Cost Flat Rate',
      edit: 'Edit Vehicle Cost Flat Rate',
      entityType: 'Type',
      noData: 'No Vehicle Cost Flat Rate available',
      createSuccess: 'Vehicle Cost Flat Rate successfully created',
      createError: 'Error creating Vehicle Cost Flat Rate',
      updateSuccess: 'Vehicle Cost Flat Rate successfully updated',
      updateError: 'Error updating Vehicle Cost Flat Rate',
      deleteConfirm: 'Do you really want to delete this Vehicle Cost Flat Rate?',
      deleteSuccess: 'Vehicle Cost Flat Rate successfully deleted',
      deleteError: 'Error deleting Vehicle Cost Flat Rate',
      types: {
        VEHICLE: 'Vehicle',
      },
    },
  },
  driver: {
    gender_MALE: 'driver(m)',
    gender_FEMALE: 'driver(f)',
    gender_DIVERS: 'driver(d)',
    plural: 'drivers',
    singular: 'driver',
    detail: 'view of driver',
    list: 'List of all selected drivers',
    new: 'new driver',
    replacementDriver: 'replacement driver',
    goToDriverDetail: 'go to selected driver',
  },
  escort: {
    singular: 'Escort employee',
  },
  employee: {
    id: 'ID',
    gender_MALE: 'employee',
    gender_FEMALE: 'employee',
    gender_DIVERS: 'employee',
    plural: 'employees',
    singular: 'employee',
    singularDelete: 'employee',
    detail: 'view of employee',
    list: 'List of all selected employees',
    new: 'new employee',
    roles: 'roles',
    unavailableFrom: 'unavailable from',
    employeeCreated: 'employee created',
    updateSuccessful: 'employee updated',
    keycloakHint: 'keycloak-hint',
    keycloakImported: 'keycloak-import successfully',
    keycloakUpdate: 'keycloak-update successfully',
    importedInKc: 'imported to keycloak',
    deleteEmployees: 'Do you want to delete this employee?',
    deleteEmployee: 'Do you want to delete these employees?',
    deleteError: 'Error while deleting an employee',
    deleteErrorMessage:
      'The employees with the following ids could not be deleted because ' +
      ' of existing relations with tours and/or vehicles: ',
    deleteErrorMessageSingle:
      'The employee could not be deleted because ' +
      ' of existing relations with tours and/or vehicles.',
    employeeNumber: 'employee number',
  },
  vehicle: {
    id: 'ID',
    singular: 'vehicle',
    plural: 'vehicles',
    licensePlate: 'license plate',
    chassisNumber: 'Chassis number',
    endOfAdmission: 'End of admission',
    engine: 'engine',
    adress: 'location of vehicle',
    vehicleRegistration: 'vehicle registration',
    vehicleRegistrationDate: 'vehicle registration date',
    usualDriver: 'regular driver of vehicle',
    constitution: 'constituion of vehicle',
    unavailableFrom: 'unavailable from',
    new: 'new vehicle',
    wheelchair_info: 'information about wheelchair availibility required',
    wheelchairSeats_info: 'information about the number of wheelchair spaces availibility required',
    liftingPlatform_info: 'information about lifting platform required',
    liftingPlatform: 'lifting platform',
    seats_info: 'information about number of seats required',
    licensePlate_info: 'license plate required',
    detail: 'view of vehicle',
    insurance: 'insurance',
    transportationOptions: 'transportation options',
    wheelchairSeats: 'of which wheelchair seats',
    seats: 'seats incl wheelchair without driver',
    seatsAbbreviated: 'seats',
    vehicleModelName: 'vehicle model name',
    vehicleType: 'vehicle type',
    goToVehicleDetail: 'go to selected vehicle',
    deleteVehicles: 'Do you want to delete this vehicle?',
    deleteVehicle: 'Do you want to delete these vehicles?',
    deleteError: 'Error while deleting a vehicle',
    deleteErrorMessage:
      'The vehicles with the following ids could not be deleted because of existing relations with tours or planned-tours: ',
    deleteErrorMessageSingle:
      'The employee could not be deleted because of existing relations with tours or planned-tours:',
    updateError: 'error updating vehicle',
    updateErrorVehicleUsed:
      'update of changed attributes impossible as vehicle is used in tours or planned-tours',
    validityOutsideGlobalDate:
      'This vehicle is not valid for the chosen date - the properties of this vehicle cannot be changed',
    vehicleTypeOptions: {
      electricity: 'electricity',
      diesel: 'diesel',
      petrol: 'petrol',
      hybrid: 'hybrid',
    },
    transportationCompany_required: 'transportation company is mandatory',
    driverRequired: 'driver is mandatory',
    vehicleTypeRequired: 'vehicle type is mandatory',
    tour: {
      tours: 'tours of vehicle',
      tours_planned: 'plannings of vehicles',
      tours_of_selected_vehicle: 'show selection for vehicles',
    },
    vehicleListWithoutDateConsideration: 'Load vehicles without date consideration',
  },
  vacation: {
    new: 'new entry',
    edit: 'edit entry',
    delete: 'delete entry',
    startDate: 'start date',
    endDate: 'end date',
    template: {
      new: 'new template',
      isPresent: 'template is present',
      singular: 'calendar template',
      plural: 'calendar templates',
      countEntries: 'count entries',
      noTemplate: 'No Calendar Template',
    },
    validFrom: 'valid from',
    validUntil: 'valid until',
  },
  basicData: {
    singular: 'setting',
    plural: 'settings',
  },
  interkommunalerLastenausgleich: {
    title: 'Interkommunaler Lastenausgleich',
    editLastenausgleichAttributes: 'Set attributes',
    selectSchool: 'Select schools',
    setParameters: 'Set parameters',
    parametersAndLayout: 'Parameter einstellen',
    stichtag: 'Schulstatistischer Stichtag',
    stichtagTooltip:
      'Only this single reference week counts. The routes from Monday to Sunday in this calendar week are extrapolated to cover all driving days of the year.',
    faktorDefaultPercent: 'Factor (percent)',
    abzugDefaultEuro: 'Deduction in EUR',
    saveAndSend: 'Generate export',
    setGlobalDate: 'Set to global date',
    setConfigDate: 'Set to default date',
  },
  exportPage: {
    navSubheader: 'Exports',
    title: 'Exports and invoices',
    dateRange: 'time period',
    generate: 'Exports',
    today: 'Today',
    tomorrow: 'Tomorrow',
    currentWeek: 'current week',
    lastWeek: 'last week',
    nextWeek: 'next week',
    currentMonth: 'current month',
    lastMonth: 'last month',
    lastThreeMonths: 'last 3 months',
    accountingType: 'accounting-type',
    reset: 'reset',
    steps: {
      last: 'Last step',
      finished: 'All steps completes',
      generate: 'Generate',
      reset: 'Restart',
      continue: 'Continue',
      back: 'Go back',
      finishedInfoStart: 'The ',
      finishedInfoEnd:
        ' can be downloaded after completion. It is now possible to create a favorite from this export.',
    },
    tours: {
      label: 'Select tours, schools or tour bundles',
      title: 'Tours',
      tours: 'Tours',
      planning: 'plannings',
      schools: 'Schools',
      transportationCompany: 'Transportation Company',
      vehicles: 'vehicles',
      employees: 'employees',
    },
    datesFormat: {
      label: 'Select date-range and document type',
      title: 'Date-range and document-type',
      from: 'From',
      until: 'Until',
    },
    exportTypes: 'Export or Invoice',
    exportTimetable: 'create timetable',
    exportTimetableHintStart: 'create timetable. Only tours that are valid on the ',
    exportTimetableHintEnd: '.',
    exportGroupEnum: {
      ACCOUNTING: 'Accounting',
      DRIVING_SERVICE_INVOICE: 'Driving service invoice',
      TENDER: 'Tender',
      TIMETABLE: 'Timetable',
      TOUR_CLASS: 'Time category',
      UNKNOWN: 'Divers',
    },
    parameters: {
      label: 'Select advanced parameters',
      title: 'Parameters',
      useEmptyKmCost: 'consider empty segments',
      respectAbsence: 'respect absences',
      respectWaitingTime: 'respect waiting time',
      overrideOccupiedDistance: 'APV-Km',
      showCosts: 'show costs',
      groupByCostcenters: 'Group By Cost Centers',
      showKm: 'show segment kilometers (only schedules)',
      invoiceWithZeroVat: 'Entire invoice with 0% VAT',
      wheelchairTransportWithZeroVat: 'Wheelchair transport: Entire tour with 0% VAT',
      wheelchairStudentsProportionallyWithZeroVat:
        'Only students transported in wheelchairs proportionally with 0% VAT',
      noParameters: 'Currently no advanced parameters!',
    },
    favorites: {
      favoriteAccounting: 'Accounting favorites',
      favoriteAccountingInfo: 'Expand the export groups and check your favorites to print.',
      noFavorites: 'No favorites saved yet. Create exports as favorites to see them in groups.',
      favoriteCreate: 'Save favorite',
      favoritePrint: 'print favorite',
      favoriteDelete: 'delete favorite',
      favoriteType: 'type',
      favoriteLoad: 'Load favorite',
      favoriteName: 'Favorite name',
      openPopUp: 'Create favorite',
      saveAs: 'Save as favorite',
    },
  },
  excelImport: {
    singular: 'excel-import',
    plural: 'excel-imports',
    upload: 'upload excel',
    search: 'search excel',
    column: 'column in excel',
    columnWithError: 'Error in these columns',
    row: 'row in excel',
    corresponding_field: 'corresponding field',
    existingEntry: 'Existing entry',
    importedEntry: 'Imported entry',
    conflictingFields: 'Conflicting fields',
    duplicateKeyFields: 'Checked fields',
    duplicatesFound: '{{count}} duplicates were detected.',
    overwrite: 'Overwrite',
    conflictResolution: {
      question: 'Should the following entries be overwritten?',
      description:
        'Select "Yes" to overwrite the existing entry with the imported data. ' +
        'Select "No" to keep the existing entry unchanged and skip this Excel row. ' +
        'After confirmation, the Excel file will be imported with the conflict decisions applied.',
      alreadyResolvedWarning:
        'This conflict resolution has already been confirmed and cannot be submitted again.',
      resolvedLabel: 'Conflict resolution confirmed',
      overwriteValidFromLabel: 'Overwrite from',
      overwriteValidFromInfo: 'The selected entries will be overwritten from this date.',
      submit: 'Confirm conflict resolution',
    },
    common: {
      yes: 'Yes',
      no: 'No',
    },
    fieldTypes: {
      text: 'text (max 255 characters)',
      transportationCompany: 'name must match the persisted transportation-companies',
      transportationModel: 'name must match the persisted standard weeks',
      vehicleSeats: 'including wheelchair-seats',
      vehicleDriverRelation:
        'value-pair in vehicle-excel and driver-excel for relation between driver and vehicle',
      number: 'number',
      coordinate: 'coordinate WGS84, EPSG: 4326 (e.g. 47,90857)',
    },
    importTypeTitle: {
      STUDENTS: 'Student',
      VEHICLES: 'Vehicle',
      EMPLOYEES: 'Driver',
      PUBLIC_TRANSPORTATION: 'public-transportation',
    },
    typesSuccess: {
      STUDENTS: 'student-Excel imported',
      VEHICLES: 'vehicle-Excel imported',
      EMPLOYEES: 'driver-Excel imported',
      PUBLIC_TRANSPORTATION: 'public-transportation-Excel imported',
    },
    typesError: {
      STUDENTS: 'student-Excel error',
      VEHICLES: 'vehicle-Excel error',
      EMPLOYEES: 'driver-Excel error',
      PUBLIC_TRANSPORTATION: 'public-transportation-Excel error',
    },
    excelTooLarge: 'excel is too large. Maximum 100.000 rows',
    excelNotFound: 'excel not found or not in .xsl or .xlsx format',
    upload_success: 'upload successfull',
    excelHeaders: 'all excel headers',
    assignment: 'assignment to database',
    uploadCustomMapping: 'import with custom mapping',
    asnyc_loading_activated:
      'async process activated. You will get notifications regarding the status',
    attributes: {
      HOUSE_NUMBER: 'house number',
      PHONE: 'phone',
      MOBILE_NUMBER: 'mobile number',
      TRANSPORT_FROM: 'transport from',
      TRANSPORT_UNTIL: 'transport until',
      CHASSIS_NUMBER: 'Chassis number',
      END_OF_ADMISSION: 'End of admission',
      FIRSTNAME: 'firstname',
      EXTENSION: 'extension',
      EMAIL: 'email',
      GENDER: 'gender',
      COMMENT: 'comment',
      DISTRICT: 'district',
      KREIS: 'administrative district',
      LOT_NUMBER: 'Lot',
      WHEELCHAIR_SITTING: 'wheelchair sitting',
      LASTNAME: 'lastname',
      POSTAL_CODE: 'postal code',
      EMPLOYEE_NUMBER: 'employee number',
      BIRTHDAY: 'birthday',
      INSTRUCTION: 'instruction',
      MOBILITY: 'mobility',
      ESCORT_INDIVIDUAL: 'escort individual',
      STREET: 'street',
      CITY: 'city',
      ADDITIONAL_INFORMATION: 'additional information',
      JUSTIFICATION: 'justification',
      ESCORT_IN_BUS: 'escort in bus',
      UTILITY: 'utility',
      WHEELCHAIR: 'wheelchair',
      HAND_TO_HAND: 'hand to hand',
      TRANSPORTATION_COMPANY: 'transportation company',
      VEHICLE_KEY_EXCEL_IMPORT: 'vehicle reference field',
      NAME: 'Name',
      LICENSE_PLATE: 'license plate',
      VEHICLE_MODEL_NAME: 'model name',
      SEATS: 'seats',
      WHEELCHAIR_SEATS: 'wheelchair seats',
      VEHICLE_TYPE: 'vehicle type',
      VEHICLE_REGISTRATION_DATE: 'registration date',
      LIFTING_PLATFORM: 'lift',
      DRIVER_KEY_EXCEL_IMPORT: 'driver reference field',
      PARENT_ONE_SALUTATION: '1. parent salutation',
      PARENT_ONE_FIRST_NAME: '1. parent first name',
      PARENT_ONE_LAST_NAME: '1. parent last name',
      PARENT_ONE_STREET: '1. parent street',
      PARENT_ONE_HOUSE_NUMBER: '1. parent house number',
      PARENT_ONE_DISTRICT: '1. parent district',
      PARENT_ONE_POSTAL_CODE: '1. parent postal code',
      PARENT_ONE_CITY: '1. parent city',
      PARENT_ONE_EMAIL: '1. parent email',
      PARENT_ONE_PHONE: '1. parent phone',
      PARENT_TWO_SALUTATION: '2. parent salutation',
      PARENT_TWO_FIRST_NAME: '2. parent first name',
      PARENT_TWO_LAST_NAME: '2. parent last name',
      PARENT_TWO_STREET: '2. parent street',
      PARENT_TWO_HOUSE_NUMBER: '2. parent house number',
      PARENT_TWO_DISTRICT: '2. parent district',
      PARENT_TWO_POSTAL_CODE: '2. parent postal code',
      PARENT_TWO_CITY: '2. parent city',
      PARENT_TWO_EMAIL: '2. parent email',
      PARENT_TWO_PHONE: '2. parent phone',
      LATITUDE: 'Latitude',
      LONGITUDE: 'Longitude',
      SCHOOL_CLASS: 'school class',
      SCHULTRAEGER: 'school authority',
      FESTSTELLUNGSBESCHEID_VALID_UNTIL: 'assessment notice valid until',
      FOERDERSCHWERPUNKT: 'special educational focus',
      ROW_IS_NULL: 'entire row is null',
      COST_AREA: 'Cost area',
      COSTCENTER: 'Cost center',
      COST_PROVIDER: 'Cost provider',
      KINDERGARTEN: 'Kindergarten',
      BAFOEG: 'BAföG',
    },
  },
  days: {
    days: 'days',
    mo: 'Mo',
    tu: 'Tu',
    we: 'We',
    th: 'Th',
    fr: 'Fr',
    sa: 'Sa',
    su: 'Su',
    1: 'Mo',
    2: 'Tu',
    3: 'We',
    4: 'Th',
    5: 'Fr',
    6: 'Sa',
    7: 'Su',
  },
  contextMenu: {
    changesValidFrom: 'changes valid from',
    tour: {
      tourBundle: 'change tour bundle',
      tourCosts: 'change tour prices',
      costOccupiedKm: 'occupied km in €',
      costEmptyKm: 'empty km in €',
      costFlatRate: 'flatrate in €',
      costAddition: 'addition in €',
      vehicleDriverEscort: 'vehicle, personnel and empty-section',
      changedVehicleHintContextMenu:
        'by default the empty-sections places will be updated accordingly to the selected vehicle place if not override by empty-section below',
      virtualVehicleEmptySectionHint:
        'At least one selected tour has a virtual vehicle on the selected date. Select a vehicle to also assign empty sections.',
      infoHeader: 'only selected values will be updated',
      toursNotUpdatable:
        'update partly successfully. The following tours could not be updated as the date of change is outside of tour validity: ',
      reroute: 'Recalculate tours',
      rerouteCurrent: 'recalculate (keep current optimization)',
      rerouteTime: 'according to time',
      rerouteDistance: 'according to distance',
      minutesAroundSchool: 'minutes before school-start/after school-end',
      minutesAroundSchoolHint: 'only numbers are accepted (no comma)',
      tourNameNumberAbbreviation: 'Tour name, number and abbreviation',
    },
    student: {
      assignTransportationModel: 'Assign standard week',
      editTransportDates: 'Edit transport dates',
      autoAssignPublicTransportationPlace: 'Automatically assign public transport stop',
      autoAssignPublicTransportationPlaceInfo:
        'This automatically assigns the nearest public transport stop to the selected students by air line.',
      autoAssignPublicTransportationPlaceSuccess: 'Public transport stop assigned automatically.',
      autoAssignPublicTransportationPlaceError:
        'Public transport stops could not be assigned automatically because no public transport stop was' +
        ' found within the surrounding area for at least one person.',
      assignTransportationModelHint:
        'The modification options are intentionally limited to avoid unforeseen changes in the past.\n\nStudents without tours: Changes possible at any time.\nStudents with tours: Changes only possible from today\'s date onwards (students will be removed from all(!) tours starting from the "valid from" date).',
      assignTransportationModelHintTwo:
        'The standard week is a template with which calendar entries for students can be created.\n\nThe standard week is set for the selected time period and the calendar entries are created accordingly. Previously, all calendar entries set by standard weeks from the "valid from" date will be deleted. Manually created calendar entries remain preserved.',
      partial_success: 'Partially successful',
      students: 'Students',
      students_assigned: 'adjusted',
      students_failed: 'not adjusted',
      reasons: 'Reasons',
      differentSchools: 'Please select only students from one school',
      errorStudentInPastTour: 'Student in past tours',
      errorStudentInDifferentSchool: 'Student in different schools',
      errorInvalidStartDate: 'Start date must be on a Monday',
      errorGeneralError: 'An error has occurred',
      createTemplatedDocuments: 'Generate Document',
    },
  },
  employeeApp: {
    title: 'employee-app',
    keycloakImport: 'employee-import to keycloak',
    syncKc: 'sync with employee-app',
    import: 'employee import to keycloak',
    timestampExportError: 'error in selected time range',
    importTableHeaders: {
      imported: 'imported',
      username: 'username / email',
      fullName: 'employee name',
      errorType: 'error type',
      errorHint: 'error hint',
    },
    importErrorType: {
      SEND_ACTIONS_EMAIL: 'error while sending email',
      CREATE_USER: 'error while createing user',
      FETCHING_TOKEN: 'authentification error',
      SETTING_PASSWORD: 'error while setting initial-password',
      NONE: 'no error',
      UPDATE_USER: 'error while updating user',
    },
    importError: {
      FAILED_TO_SEND_EXECUTION_EMAIL:
        'error while sending execution email - please contact the support',
      USER_EXISTS_SAME_USERNAME: 'user exists with same username ',
      UNKNOWN_ERROR: 'unkown error',
    },
    messages: {
      plural: 'messages',
      singular: 'message',
      employeeNumber: 'employee number',
      firstName: 'first name',
      lastName: 'last name',
      phone: 'phone',
      mobile: ' mobile',
      email: 'email',
      employeeId: 'employee id',
      send: 'send message',
      select_date: 'message visible at',
      send_message_to: 'send message to',
      message_history: 'message history',
      messages_for: 'messages send to: ',
      at: 'at',
    },
    export: {
      singular: 'Export',
      download: 'Download',
      download_work_times: 'download work times',
      info: 'Work times excel-sheet of all employees',
    },
    comparison: {
      title: 'Track-Tour comparison',
      id: 'ID',
      trackId: 'Track',
      tourId: 'Tour',
      employeeId: 'Driver',
      trackDate: 'Date',
      createdAt: 'Created at',
      algorithm: 'Comparison',
      durationDifferenceAbsolute: 'Time of track (Sec.)',
      durationDifferenceRelative: 'Relative time (Sec.)',
      distanceDifferenceAbsolute: 'Distance of track (m)',
      distanceDifferenceRelative: 'Relative distance (m)',
      otherResult: 'Other result',
      noTourAtDate: 'Tour has no instance on this date',
      noTour: 'Track has no tour',
    },
  },
  tourWizard: {
    makeAdjustmentsInEvent: 'Please follow the steps to make adjustments in the event',
    checkAffectedTours: 'Checking affected tours',
    createDeviationEvent: 'Firstly, create a new deviation event',
    alternativeTours: 'List of alternative tours',
    assignStudent: 'Assign student to any one of alternative tours below',
    createNewTour: 'Create a new tour',
    enterTourInformation: 'Enter new tour information',
    addStudentToTour: 'Add student to selected tour',
    newDeviationEventInformation: 'Enter new deviation event information',
    selectAlternativeToursOrCreateNewTour:
      'You can either select one of alternative tours or create a new tour for the student',
    affectedTours: 'List of all affected tours',
    affectedStudents: 'List of all affected students',
    studentsRemainInTour: 'Student remain in selected tours',
    removeStudentsFromTours: 'Remove student from selected tours',
    addStudentToAlternativeTour: 'Add student to selected tour',
    showAlternativeTours: 'Show alternative tours',
    studentsRemainInTourInformation:
      'The passenger remains in the previous tours with his new stopping point and the selected tours are recalculated.',
    removeStudentsFromToursInformation:
      'The passenger is removed from the selected tours and the selected tours are then recalculated.',
    addStudentToAlternativeTourInformation: 'The passenger is added in the selected tour.',
    enable: 'Enable',
    disable: 'Disable',
    advancedFiltering: 'advanced filtering',
    warningOnlySelectOne: 'Please select single tour',
    changedToursInformationAfterChangeOfPlaceOrSchoolHour: 'Changes of tours',
    followingToursWereChanged:
      'The following tours have changed or have been newly created after the ' +
      'removal of the student:',
    confirmCloseMessage:
      'If you close the dialog, the student will be removed from all affected tours starting from the ' +
      'date of the address change.',
    confirmClose: 'Close Tour Wizard',
  },
  tourTransform: {
    error: 'Not all tours could be transformed.',
    partiallyDone: ' planned-tours were not transformed.',
    resultId: 'Result ID:',
    convertedTours: 'Converted Tours:',
    notConvertedAndOverlapTours: 'Tours that were not converted and their overlaps:',
    overlapTours: 'Overlap Tours',
    conflictingTours: 'conflicting tours',
    conflictTour: 'conflict tour',
    conflictingPlaces: 'place-conflict (only considers first planning week)',
    multipleTransportationModel:
      'There are multiple standard weeks connected to the planning period of the tour.' +
      ' Please adapt the corresponding events or the validity of the tour.',
    noPlaceDifferences: 'equal places',
    noOverlappingTour: 'no overlapping tour',
  },
  transportationNeedCheck: {
    info: 'Ergebnis transportation need check',
    infoTitle: 'Overview of the transportation need of selected students',
    createTitle: 'Check transportation need',
    toDates: 'To tours',
    fromDates: 'From tours',
    transferDates: 'Transfer tours',
    unfulfilledTransportationNeed: 'Transportation need unfulfilled',
    fulfilledTransportationNeed: 'Transportation need fulfilled',
    amountOfCheckedStudentsInfo: 'Amount of checked students:',
    studentsWithUnfulfilledTransportationNeed:
      'Amount of students with unfulfilled transportation need:',
    datesWithNotFulfilledTransportationNeed: 'Date ranges for unfulfilled transportation need',
    checkFrom: 'Check from',
    checkUntil: 'Check until',
    startCheck: 'Start check',
    dateRangeForCheck: 'Check-period',
    dateRangeForCheckFail: ' Period fail',
    transportationNeedCalculationTitle: 'Check transportation need',
    transportationNeedCalculation: 'Transportation need is calculating',
    transportationNeedCalculationFail: 'Transportation need check failed',
    studentsWithTransportationNeedTo: 'For to tours',
    studentsWithTransportationNeedTransfer: 'For transfer tours',
    studentsWithTransportationNeedFrom: 'For from tours',
  },
  globalMap: {
    title: 'Map',
    clearMap: 'Clear map',
    openList: 'Open list',
    closeList: 'Close list',
    fullscreen: 'Full screen',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    opacity: 'Set opacity',
    person: 'Pax',
    zoomInMap: 'Zoom in map',
    search: 'Search address',
    legend: 'Legend',
    base: 'Base',
    filterBySchoolTransportationTime: 'Filter tours and students',
    filterBySchoolTransportationTimeTooltip:
      'Tours are filtered by all selected attributes. Students are filtered based on the selected school.',
    studentButtonToolTip: 'Please highlight exactly one tour',
    enabled: 'Enabled',
    disabled: 'Disabled',
    tourReason: 'Tour reason',
    tourType: 'Tour type',
    selectedSchools: 'Selected schools',
    showFilters: 'Show filters',
    hideFilters: 'Hide filters',
    removeSchool: 'Remove school',
    tourStop: 'Show stops',
    recalculateTour: 'Recalculate daily tours',
    noOfRowsSelected: 'Total {{selected}} from {{total}}',
    totalRows: 'Total Rows {{total}}',
    needHelp: 'Need Help?',
    showEmptySections: 'Show empty sections',
    showDirectionArrows: 'Show direction arrows',
    showPublicTransports: 'Show public transports',
    showPublicTransportConnections: 'Air line between public transport stops and home address',
    publicTransportConnectionLine: 'Air line home address ↔ public transport stop',
    showMandatoryRoutingPoints: 'Show mandatory routing points',
    showRoadblocks: 'Show roadblocks',
    mapType: 'Types of map',
    osm: 'OpenStreetMap',
    wmts: 'basemap.de',
    moreOptions: 'More options',
    noToursInMap: 'No tours could be loaded at the selected date',
    noToursInMapInfo:
      'Possible reasons might be: Tour is not driving at selected date or selected date lays within vacations',
    tourTimeline: 'Parts tournumber',
    noTourNumber: 'No tour number was found for the selected tour',
  },
  placeType: {
    HOME: 'Home',
    SCHOOL: 'Institution',
    TECHNICAL: 'Technical',
    TRANSPORTATION: 'Transportation',
    SCHOOLCENTER: 'School Center',
    PLACE_PICKER_GEOCODED: 'Place Picker Geocoded',
    PUBLIC_TRANSPORT: 'Public Transport',
    MANDATORY_ROUTING_POINT: ' Mandatory routing point',
  },
  placeManagement: {
    title: 'place management',
    type: 'place-type',
    new: 'new place',
    editPlace: 'edit place type / name',
    delete: 'delete place',
    deleteTitle: 'Error deleting place',
    deleteError: 'place is referenced in the system. Deleting is impossible',
  },
  documentManagement: {
    title: 'Title',
    date: 'Date',
    titleRequired: 'Title is required',
    upload: 'Upload',
    download: 'Download',
    uploadSuccess: 'Document uploaded successfully',
    documentTooLarge: 'Document is too large',
    errorSaving: 'Error saving document',
    origFilename: 'Name',
    size: 'Size',
    fileType: 'Type',
    username: 'Username',
    delete: 'Delete',
    errorLoadingDocuments: 'Error loading documents',
    askDeleteDocument: 'Do you really want to delete this document?',
  },
  tourPlanningWizard: {
    title: 'Return Tour Wizard',
    nextStep: 'Next',
    status: 'Status',
    planning: 'Planning started ...',
    statusOptions: {
      NO_TOUR: 'Same combination of students not possible',
      TOUR: 'Same combination of students possible',
    },
    matrixHeaders: {
      id: 'ID',
      name: 'Tour',
      student: 'Student',
      moFrom: 'Mo',
      tuFrom: 'Tu',
      weFrom: 'We',
      thFrom: 'Th',
      frFrom: 'Fr',
    },
    close: 'Close Wizard',
  },
  roadblockManagement: {
    label: 'Roadblock',
    listTitle: 'Roadblocks',
    roadblockPoint: 'Roadblock',
    title: 'Roadblock management',
    type: 'Type',
    new: 'new roadblock',
    edit: 'update roadblock',
    delete: 'delete roadblock',
    deactivate: 'deactivate roadblock',
    activate: 'activate roadblock',
    deactivateInfo:
      'Roadblocks which are deactivated will not be considered in future tours. Affected tours must be manually rerouted when roadblocks are deactivated. \n\n Are you sure to decativate the roadblock?',
    deleteTitle: 'Deleting roadblock failed',
    deactivateTitle: 'Deactivating roadblock failed',
    validFrom: 'Valid from',
    validUntil: 'Valid until',
    save: 'Create roadblock',
    affectedTours: 'Affected tours',
    createRoadblock: 'Create roadblock',
    unnamed: 'Unnamed',
    infoTitle: 'Informationen zu Straßensperrungen',
    infoText:
      'Eine angelegte Straßensperrung ist gültig nach dem Erstellen und ist zeitunabhängig. Touren, die bereits,' +
      'im System hinterlegt sind, müssen neu berechnet werden. Touren die nachträglich erstellt werden berücksichtigen ' +
      'alle bereits angelegten Straßensperrungen.',
    deleteError: 'Error deleting roadblock',
    rerouteAffectedTours: 'Reroute Affected Tours',
    rerouteAffectedToursDescription:
      'All selected tours will be recalculated using the method you selected.' +
      ' The recalculated tours can still be found under the affected tours of the ' +
      'road closures. No tour periods will be adjusted.',
    noToursSelected: 'No tours selected',
    noToursToReroute: 'No tours available to reroute',
    rerouteRequestSuccessful:
      'Die Neuberechnung der betroffenen Touren wurde erfolgreich abgeschickt.',
    rerouteFailed:
      'Das Rerouting der betroffenen Touren ist fehlgeschlagen. Bitte wenden sie sich an einen' +
      ' Administrator.',
    reroute: 'Routen neu berechnen',
    inactiveRoadblockNoTours:
      'The selected roadblock is deactivated. To see affected tours roadblocks have to be ' +
      'activated.',
    selectRoadblockToViewTours: 'Select a roadblock to see affected tours.',
  },
  analysis: {
    plural: 'Analyses',
    singular: 'Analysis',
  },
  releaseNotes: {
    title: "What's new",
    description: 'New features and improvements in TerraIndividual',
    open: "Open what's new",
    close: "Close what's new",
    view: 'View',
    dismiss: 'Dismiss notification',
    version: 'Version',
    latest: 'Latest',
    loading: 'Loading updates…',
    unavailable: 'Updates are currently unavailable.',
    empty: 'There are currently no updates.',
    changeTypes: {
      new: 'New',
      improved: 'Improved',
      fixed: 'Fixed',
    },
  },
  timelineGroup: {
    TO: 'outward journey',
    FROM: 'return journey',
    VEHICLE: 'vehicle',
    EMPLOYEE: 'employee',
    students: 'students',
  },
};

export default en;
